<template>
	<div class="puiformheader" v-if="model">
		<v-layout wrap>
			<v-flex xs4 md3>
				<pui-field :label="this.$t('grid.ticketbatch.ticketbatchdescription')" :value="getTicketBatchName"></pui-field>
			</v-flex>
			<v-flex xs4 md3>
				<pui-field :label="this.$t('grid.ticketbatch.ticketbatchprice')" :value="getTicketBatchPrice"></pui-field>
			</v-flex>
			<v-flex xs4 md3>
				<pui-field :label="this.$t('grid.ticketbatch.ticketbatchpricecurrency')" :value="getticketbatchPriceCurrency"></pui-field>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import PuiFormHeaderMixin from 'pui9-mixins/PuiFormHeaderMixin';

export default {
	name: 'ticketbatchformheader',
	mixins: [PuiFormHeaderMixin],
	data() {
		return {
			modelName: 'ticketbatch'
		};
	},
	computed: {
		getTicketBatchName() {
			return this.model && this.model.ticketbatchdescription ? this.model.ticketbatchdescription : 'error';
		},
		getTicketBatchPrice() {
			return this.model && this.model.ticketbatchprice ? this.model.ticketbatchprice : 0;
			/* return this.model && this.model.ticketbatchprice
				? this.model.ticketbatchprice
				: this.model.ticketbatchprice === null || this.model.ticketbatchprice === ''
				? 0
				: 'error'; */
		},
		getticketbatchPriceCurrency() {
			return this.model && this.model.ticketbatchpricecurrency ? this.model.ticketbatchpricecurrency : 'error';
		}
	}
};
</script>
